import {getmessage} from '../../api/message'

const message = {
  state: {
    unread_msg: sessionStorage.getItem('unread_msg')
  },
  mutations: {
    set_unread(state, num) {
      state.unread_msg = num;
      sessionStorage.unread_msg = num;
    },
    del_unread(state) {
      state.unread_msg = '';
      sessionStorage.removeItem('unread_msg')
    }
  },
  actions: {
    // 获取系统消息
    getmessage({commit}) {
      return new Promise((resolve, reject) => {
        getmessage().then(response => {
          let data = response.data;
          if (data.code == 200) {
            let msg = data.data;
            let unread = [];
            if (msg.out) {
              let out = {tit: msg.out, type: 'out'};
              unread.push(out);
            }
            if (msg.refund) {
              let out2 = {tit: msg.refund, type: 'refund'};
              unread.push(out2);
            }
            if (unread.length > 0) {
              commit('set_unread', unread.length);
            } else {
              commit('del_unread');
            }
            resolve(unread)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
};

export default message



// WEBPACK FOOTER //
// ./src/store/modules/message.js